export default "__VITE_ASSET__BQET1Y0H__"